function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { merge, isEmpty } from 'lodash';
import { SearchQuery } from '../models/search-query';
var DEFAULT_SERVER_ENDPOINT = 'http://localhost:9002/svc/search';
var DEFAULT_CLIENT_ENDOINT = '/wsvc/search';
var emptyResponse = query => ({
  searchResults: [],
  totalHits: 0,
  numPages: 0,
  query: query.toQueryObject()
});
export class SearchApiBackend {
  constructor() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isServerSide = _ref.isServerSide,
      endpoint = _ref.endpoint,
      credentials = _ref.credentials;
    _defineProperty(this, "endpoint", void 0);
    _defineProperty(this, "isServerSide", void 0);
    _defineProperty(this, "credentials", void 0);
    this.endpoint = endpoint || (isServerSide ? DEFAULT_SERVER_ENDPOINT : DEFAULT_CLIENT_ENDOINT);
    this.isServerSide = isServerSide || false;
    this.credentials = credentials;
    this.getOptions = this.getOptions.bind(this);
    this.fetchListings = this.fetchListings.bind(this);
  }
  getOptions(query) {
    var queryObject = query.toQueryObject();
    var basicAuthHeader = this.credentials ? {
      headers: {
        Authorization: "Basic ".concat(this.credentials)
      }
    } : {};
    return merge({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(queryObject)
    }, this.isServerSide && basicAuthHeader);
  }
  fetchListings(listingType, query) {
    if (!(listingType && query)) {
      return Promise.reject(new Error('Listing type and query not specified'));
    }
    var searchQuery = SearchQuery.fromPossibleQueryObject(listingType, query);
    if (isEmpty(searchQuery.getLocalities()) && isEmpty(searchQuery.getBounds())) {
      return Promise.resolve(emptyResponse(searchQuery));
    }
    var requestUrl = "".concat(this.endpoint, "/").concat(listingType.pageContext);
    return fetch(requestUrl, this.getOptions(searchQuery)).then(response => {
      if (!response.ok) {
        return Promise.reject(new Error("Failed to fetch listings - ".concat(response.statusText, " ").concat(response.status)));
      }
      return response.json();
    });
  }
}